import Aurora from '../home/components/Aurora';
import { CursorGlow } from '../home/components/CursorGlow';
import { ContactSection } from '../home/components/ContactSection';

export default function ContactPage() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Aurora Background */}
      <div className="fixed inset-0 z-0">
        <Aurora 
          colorStops={['#ed66ff', '#b19eef', '#5227ff']}
          amplitude={1.2}
          blend={0.6}
          speed={0.8}
        />
      </div>

      {/* Global Effects */}
      <CursorGlow />

      {/* Content */}
      <div className="relative z-10">
        <div className="absolute inset-0 bg-black/30"></div>
        
        <div className="relative z-10 pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-20 md:pb-24">
          <div className="container mx-auto px-4 sm:px-6">
            {/* Header */}
            <div className="text-center mb-12 sm:mb-16">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.1em] px-4">
                GET IN <span className="bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">TOUCH</span>
              </h1>
              <p className="text-gray-400 text-base sm:text-lg md:text-xl max-w-3xl mx-auto font-light leading-relaxed px-4">
                Ready to transform your business? Let's start a conversation
              </p>
            </div>

            {/* Contact Section */}
            <ContactSection />
          </div>
        </div>
      </div>
    </div>
  );
}
